export function getExternalMeetingIdFromURL() {
    /**TODO: should be improved and tested */

    if (window.location.pathname.includes("meetingV2")) {
        return window.location.pathname.split("/")[2] || ""
    }

    return ""
}
